module.exports = __webpack_public_path__ + "img/default_avatar.5deaf7fb.jpg";